module.exports = __webpack_public_path__ + "assets/img/Type E (36).f87ad026.jpg";